export default {
  'sm': 480,
  'mobile-s': 360,
  'mobile-md': 375,
  'mobile-lg': 414,
  'mobile-last': 576,
  'tablet-sm': 640,
  'tablet': 768,
  'new-tablet': 800,
  'tablet-album': 1024,
  'desktop': 1200,
  'sidebar': 1380,
  'desktop-mid': 1440,
  'desktop-big': 1920,
}
